'use client';

import { PhoneCampaign } from '@hc-frontend/core-types';
import { createContext, useContext, useMemo } from 'react';

import type { PhoneCampaignProviderProps } from './use-phone-campaign.types';

const PhoneCampaignContext = createContext<PhoneCampaign | null>(null);

export const usePhoneCampaign = () => useContext(PhoneCampaignContext);

export function PhoneCampaignProvider({
  children,
  phoneCampaign,
}: PhoneCampaignProviderProps) {
  const value = useMemo(() => phoneCampaign, [phoneCampaign]);

  return (
    <PhoneCampaignContext.Provider value={value}>
      {children}
    </PhoneCampaignContext.Provider>
  );
}
